import { createContext } from 'react';
export const MediaQueriesContext = createContext({
    screenXl: false,
    screenLg: false,
    screenLgMax: false,
    screenMd: false,
    screenMdMax: false,
    screenSm: false,
    screenSmMax: false,
    screenXs: false,
    screenXsMax: false,
    screenXxsMax: false,
});
